import React from 'react'
import { css } from '@emotion/core'
import { Button } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'

const header = css`
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  padding-inline-end: 0px;
  padding-bottom: 0px;
  padding-inline-start: 0px;
`

const floatRightCss = css`
  justify-content: flex-end;
`

export default function DetailHeader({ heading, showHiddenDetails, toggleShowItemHiddenDetails }) {
  return (
    <div css={header}>
      <span>{heading}</span>
      <span css={floatRightCss}>
        <Button
          Icon={ArrowCaret}
          iconDirection={showHiddenDetails ? 'up' : 'down'}
          onClick={toggleShowItemHiddenDetails}
        />
      </span>
    </div>
  )
}
